/* ==========================================================================
   Barkleys Product v2 — buy box controller

   Posts { id, quantity, selling_plan } to cart/add.js. Recharge runs on native
   Shopify selling plans, so the subscription is created by Shopify at checkout
   and lands in Recharge exactly as it does from their own widget.

   Performs NO currency arithmetic. Every money string is pre-rendered by
   Liquid and looked up by key.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.bpReady === '1') return;
    root.dataset.bpReady = '1';

    var raw = root.querySelector('[data-bpv2-data]');
    var D;
    try { D = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!D || !D.variants || !D.variants.length) return;

    var ppdOn = root.dataset.ppd === '1';

    var el = {
      price: root.querySelector('[data-bp-price]'),
      was: root.querySelector('[data-bp-was]'),
      per: root.querySelector('[data-bp-per]'),
      qty: root.querySelector('[data-bp-qty]'),
      weight: root.querySelector('[data-bp-weight]'),
      weightNum: root.querySelector('[data-bp-weight-num]'),
      monthBags: root.querySelector('[data-bp-monthbags]'),
      dognote: root.querySelector('[data-bp-dognote]'),
      mmsg: root.querySelector('[data-bp-mmsg]'),
      mfill: root.querySelector('[data-bp-mfill]'),
      subbadge: root.querySelector('[data-bp-subbadge]'),
      subwas: root.querySelector('[data-bp-subwas]'),
      subnow: root.querySelector('[data-bp-subnow]'),
      subppd: root.querySelector('[data-bp-subppd]'),
      oneppd: root.querySelector('[data-bp-oneppd]'),
      onenow: root.querySelector('[data-bp-onenow]'),
      benSave: root.querySelector('[data-bp-benefit-save]'),
      freq: root.querySelector('[data-bp-freq]'),
      err: root.querySelector('[data-bp-err]'),
      qtyVal: root.querySelector('[data-bp-qty-val]'),
      qtyDec: root.querySelector('[data-bp-qty-dec]'),
      qtyInc: root.querySelector('[data-bp-qty-inc]'),
      qtyNote: root.querySelector('[data-bp-qtynote]'),
      sticky: root.querySelector('[data-bp-sticky]'),
      sname: root.querySelector('[data-bp-sname]'),
      ssub: root.querySelector('[data-bp-ssub]')
    };

    var state = {
      variantId: null,
      mode: 'sub',                 // Subscribe & Save preselected
      weeks: null,
      weight: el.weight ? parseInt(el.weight.value, 10) : 50,
      qty: 1
    };
    // Carried over when a flavour swap replaces this element, so the shopper
    // does not have to re-enter their dog's weight for every flavour.
    if (root.dataset.bpCarryWeight) {
      var cw = parseInt(root.dataset.bpCarryWeight, 10);
      if (cw) { state.weight = cw; if (el.weight) el.weight.value = cw; }
    }
    if (root.dataset.bpCarryQty) {
      var cq = parseInt(root.dataset.bpCarryQty, 10);
      if (cq) state.qty = cq;
    }
    var QTY_MAX = Math.max(1, parseInt(D.qtyMax, 10) || 10);

    function variant() {
      for (var i = 0; i < D.variants.length; i++) {
        if (D.variants[i].id === state.variantId) return D.variants[i];
      }
      return D.variants[0];
    }
    function plans() { return variant().plans || []; }
    function plan() {
      var ps = plans(), i;
      for (i = 0; i < ps.length; i++) if (ps[i].weeks === state.weeks) return ps[i];
      return ps[0] || null;
    }
    // Sub per-day is looked up by the plan actually selected, so a variant whose
    // discount tier differs (15% at 3 bags, 20% at 6) resolves correctly.
    function ppdSub() {
      if (!ppdOn || !D.perDay) return null;
      var pl = plan();
      if (!pl) return null;
      return D.perDay[variant().id + '|' + pl.planId + '|' + state.weight] || null;
    }
    function ppdOne() {
      if (!ppdOn || !D.perDay) return null;
      return D.perDay[variant().id + '|one|' + state.weight] || null;
    }
    // Typed values are snapped to the steps the Liquid maps were built on, so a
    // figure is never shown for a weight we have not actually costed.
    function snapWeight(n) {
      var min = parseInt(el.weight && el.weight.min, 10) || 10;
      var max = parseInt(el.weight && el.weight.max, 10) || 120;
      var st = parseInt(el.weight && el.weight.step, 10) || 10;
      if (isNaN(n)) return state.weight;
      n = Math.min(max, Math.max(min, n));
      return Math.round((n - min) / st) * st + min;
    }
    function paintRangeFill() {
      if (!el.weight) return;
      var min = parseInt(el.weight.min, 10) || 0;
      var max = parseInt(el.weight.max, 10) || 100;
      var pct = ((state.weight - min) / (max - min)) * 100;
      el.weight.style.setProperty('--bp-fill', pct + '%');
    }
    function supply() {
      if (!ppdOn || !D.supply) return null;
      return D.supply[variant().id + '|' + state.weight] || null;
    }
    function setErr(m) {
      if (!el.err) return;
      el.err.textContent = m || '';
      el.err.hidden = !m;
    }

    /* ---------- render ---------- */

    function renderQty() {
      if (!el.qty) return;
      Array.prototype.forEach.call(el.qty.querySelectorAll('[data-bp-variant]'), function (node) {
        var id = parseInt(node.getAttribute('data-bp-variant'), 10);
        var vd = null, i;
        for (i = 0; i < D.variants.length; i++) if (D.variants[i].id === id) vd = D.variants[i];
        node.setAttribute('aria-checked', id === state.variantId ? 'true' : 'false');
        if (!vd) return;

        var unit = node.querySelector('[data-bp-q-unit]');
        if (unit) unit.textContent = vd.unitLabel || '';

        var save = node.querySelector('[data-bp-q-save]');
        if (save) {
          var pl = (vd.plans && vd.plans[0]) || null;
          save.textContent = pl && pl.savesMoney ? 'Save ' + pl.pct + '%' : '\u00A0';
        }

        // "Most popular" tag, matched on variant title
        if (D.popularVariant && vd.title &&
            vd.title.toLowerCase().trim() === String(D.popularVariant).toLowerCase().trim() &&
            !node.querySelector('.tag')) {
          var tag = document.createElement('span');
          tag.className = 'tag';
          tag.textContent = D.popularLabel || 'Most popular';
          node.appendChild(tag);
        }
      });
    }

    function renderFreq() {
      if (!el.freq) return;
      var ps = plans();
      if (!ps.length) { el.freq.innerHTML = ''; return; }
      var html = '';
      ps.forEach(function (pl) {
        html += '<button type="button" class="bp-fb" data-bp-weeks="' + pl.weeks + '" aria-pressed="' +
          (pl.weeks === state.weeks ? 'true' : 'false') + '">' + pl.weeks + ' weeks</button>';
      });
      el.freq.innerHTML = html;
    }

    function renderPlans() {
      var vd = variant();
      var pl = plan();

      if (el.onenow) el.onenow.textContent = vd.price;

      if (pl) {
        if (el.subnow) el.subnow.textContent = pl.price;
        if (el.subwas) { el.subwas.textContent = vd.price; el.subwas.hidden = !pl.savesMoney; }
        if (el.subbadge) {
          el.subbadge.textContent = 'Save ' + pl.pct + '% off';
          el.subbadge.hidden = !pl.savesMoney;
        }
        if (el.benSave && D.saveTemplate) {
          el.benSave.innerHTML = String(D.saveTemplate).replace('[amount]', '<b>' + pl.saved + '</b>');
        }
      } else {
        if (el.subnow) el.subnow.textContent = vd.price;
        if (el.subwas) el.subwas.hidden = true;
        if (el.subbadge) el.subbadge.hidden = true;
        if (el.benSave) el.benSave.textContent = 'Subscription not available for this size';
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-bp-mode]'), function (node) {
        node.setAttribute('aria-checked', node.getAttribute('data-bp-mode') === state.mode ? 'true' : 'false');
      });
    }

    function renderPrice() {
      var vd = variant();
      var pl = plan();
      var showing = (state.mode === 'sub' && pl) ? pl.price : vd.price;
      if (el.price) el.price.textContent = showing;
      if (el.was) {
        var show = state.mode === 'sub' && pl && pl.savesMoney;
        el.was.textContent = vd.price;
        el.was.hidden = !show;
      }
      if (el.per) el.per.textContent = vd.unitLabel || '';
    }

    function renderPpd() {
      if (!ppdOn) return;
      if (el.weightNum && String(el.weightNum.value) !== String(state.weight)) {
        el.weightNum.value = state.weight;
      }
      if (el.weight && String(el.weight.value) !== String(state.weight)) {
        el.weight.value = state.weight;
      }
      paintRangeFill();
      if (el.monthBags) {
        var m = D.monthly ? D.monthly[state.weight] : null;
        el.monthBags.textContent = m ? m : '\u2014';
      }
      var s = ppdSub();
      var o = ppdOne();
      var sup = supply();
      if (el.subppd) el.subppd.textContent = s || o || '—';
      if (el.oneppd) el.oneppd.textContent = o || '—';
      if (el.dognote) {
        if (!sup) { el.dognote.textContent = ''; return; }
        // Days of supply scales with quantity. Cost per day does not: price and
        // days both scale linearly, so the ratio is unchanged.
        var days = sup.days * state.qty;
        var qtyBit = state.qty > 1 ? (state.qty + ' × this size lasts') : 'this size lasts';
        var plus = sup.openEnded ? '+' : '';
        var mode = parseInt(D.feedingMode, 10);
        if (isNaN(mode) || mode <= 0) mode = 100;

        // State the feeding-guide figure first and the Barkley's portion second.
        // Showing only the scaled number made the page contradict the Feeding
        // Guide accordion directly beneath it.
        var txt = 'Feeding guide: about ' + sup.cupsFull + plus + ' cups a day.';
        if (mode < 100) {
          txt += " Barkley's at " + mode + '% of the bowl is ' + sup.cups + plus + ' cups — ';
        } else {
          txt += ' ';
        }
        txt += qtyBit + ' roughly ' + days + ' days.';
        el.dognote.textContent = txt;
      }
    }

    function renderQtyStepper() {
      if (!el.qtyVal) return;
      el.qtyVal.textContent = state.qty;
      if (el.qtyDec) el.qtyDec.disabled = state.qty <= 1;
      if (el.qtyInc) el.qtyInc.disabled = state.qty >= QTY_MAX;
      if (el.qtyNote) {
        var vd = variant();
        if (state.qty > 1 && vd.bags) {
          el.qtyNote.textContent = state.qty + ' × ' + vd.title + ' · ' + (vd.bags * state.qty) + ' bags total';
          el.qtyNote.hidden = false;
        } else {
          el.qtyNote.textContent = '';
          el.qtyNote.hidden = true;
        }
      }
    }

    function renderMeter() {
      if (!el.mmsg || !el.mfill) return;
      var vd = variant();
      var pl = plan();
      var lineCents = ((state.mode === 'sub' && pl) ? pl.priceCents : vd.priceCents) * state.qty;
      var total = (D.cartTotalCents || 0) + lineCents;
      var need = D.freeShipThreshold || 0;
      if (!need) { el.mmsg.textContent = ''; el.mfill.style.width = '100%'; return; }
      var pct = Math.min(100, Math.round(total / need * 100));
      el.mfill.style.width = pct + '%';
      if (total >= need) {
        el.mmsg.textContent = '\u2713 ' + (D.meterWin || '');
      } else {
        // No currency maths: fall back to the plain threshold message.
        el.mmsg.textContent = String(D.meterAdd || '').replace('[amount]', 'more');
      }
    }

    function renderSticky() {
      if (!el.sname) return;
      var vd = variant();
      var pl = plan();
      var q = state.qty > 1 ? (state.qty + ' × ') : '';
      el.sname.textContent = q + vd.title + ' · ' + (state.mode === 'sub' ? (D.subTitle || '') : (D.oneTitle || ''));
      if (el.ssub) {
        el.ssub.textContent = (state.mode === 'sub' && pl)
          ? pl.price + ' · every ' + pl.weeks + ' weeks'
          : vd.price;
      }
    }

    function renderAll() {
      renderQty(); renderFreq(); renderPlans(); renderPrice(); renderPpd();
      renderQtyStepper(); renderMeter(); renderSticky();
    }

    /* ---------- events ---------- */

    if (el.qty) {
      el.qty.addEventListener('click', function (e) {
        var node = e.target.closest('[data-bp-variant]');
        if (!node || node.hasAttribute('disabled')) return;
        state.variantId = parseInt(node.getAttribute('data-bp-variant'), 10);
        var ps = plans();
        if (!ps.length) { state.mode = 'one'; state.weeks = null; }
        else if (!ps.some(function (x) { return x.weeks === state.weeks; })) { state.weeks = ps[0].weeks; }
        setErr('');
        renderAll();
      });
      el.qty.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var node = e.target.closest('[data-bp-variant]');
        if (!node) return;
        e.preventDefault();
        node.click();
      });
    }

    root.querySelectorAll('[data-bp-mode]').forEach(function (node) {
      function pick() {
        var m = node.getAttribute('data-bp-mode');
        if (m === 'sub' && !plans().length) { setErr('Subscription is not available for this size.'); return; }
        state.mode = m;
        setErr('');
        renderAll();
      }
      node.addEventListener('click', pick);
      node.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    if (el.freq) {
      el.freq.addEventListener('click', function (e) {
        var b = e.target.closest('[data-bp-weeks]');
        if (!b) return;
        state.weeks = parseInt(b.getAttribute('data-bp-weeks'), 10);
        state.mode = 'sub';
        renderAll();
      });
    }

    function setQty(n) {
      state.qty = Math.min(QTY_MAX, Math.max(1, n));
      renderQtyStepper(); renderPpd(); renderMeter(); renderSticky();
    }
    if (el.qtyDec) el.qtyDec.addEventListener('click', function () { setQty(state.qty - 1); });
    if (el.qtyInc) el.qtyInc.addEventListener('click', function () { setQty(state.qty + 1); });

    if (el.weight) {
      el.weight.addEventListener('input', function () {
        state.weight = snapWeight(parseInt(el.weight.value, 10));
        renderPpd();
      });
    }
    if (el.weightNum) {
      // Commit on blur/Enter rather than each keystroke, so typing "120" does
      // not thrash through 1 and 12 on the way.
      var commitNum = function () {
        state.weight = snapWeight(parseInt(el.weightNum.value, 10));
        renderPpd();
      };
      el.weightNum.addEventListener('change', commitNum);
      el.weightNum.addEventListener('blur', commitNum);
      el.weightNum.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); commitNum(); el.weightNum.blur(); }
      });
    }

    /* ---------- add to cart ---------- */

    function addToCart(btn) {
      var vd = variant();
      var pl = plan();
      if (state.mode === 'sub' && !pl) { setErr('Subscription is not available for this size.'); return; }

      var payload = { id: vd.id, quantity: state.qty };
      if (state.mode === 'sub' && pl) payload.selling_plan = pl.planId;

      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      btn.disabled = true;
      setErr('');

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [payload], sections: ['cart-ajax'] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || 'Could not add to cart.');
            return data;
          });
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: { product: data, addToCartBtn: btn }
          }));
        })
        .catch(function (err) {
          setErr(err.message || 'Could not add to cart. Please try again.');
        })
        .then(function () { btn.disabled = false; });
    }

    root.querySelectorAll('[data-bp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn); });
    });

    /* ---------- flavour swap ----------
       Progressive enhancement. The swatches are real <a> links, so this works
       with JS off, for crawlers, and for middle-click / open-in-new-tab. When
       JS is available we fetch the same section rendered for the other product
       and swap it in place, which is what makes it feel like one PDP.
       Any failure falls through to normal navigation rather than dead-ending. */
    var flavWrap = root.querySelector('[data-bp-flavors]');
    if (flavWrap && D.swapFlavors && D.sectionId) {
      flavWrap.addEventListener('click', function (e) {
        var link = e.target.closest('[data-bp-flavor]');
        if (!link) return;
        if (link.getAttribute('aria-current') === 'true') { e.preventDefault(); return; }
        // Let the browser handle modified clicks so new-tab still works.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

        e.preventDefault();
        var url = link.getAttribute('href');
        link.classList.add('is-loading');

        var sep = url.indexOf('?') === -1 ? '?' : '&';
        fetch(url + sep + 'section_id=' + encodeURIComponent(D.sectionId), { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status');
            return res.text();
          })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('[data-bpv2]');
            if (!fresh) throw new Error('section not found in response');

            fresh.dataset.bpCarryWeight = state.weight;
            fresh.dataset.bpCarryQty = state.qty;

            root.replaceWith(fresh);
            init(fresh);

            if (window.history && window.history.pushState) {
              window.history.pushState({ bpv2: true }, '', url);
            }
            var top = fresh.getBoundingClientRect().top + window.pageYOffset - 90;
            if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'auto' });
          })
          .catch(function () {
            window.location.href = url;   // fall back to a normal page load
          });
      });
    }

    /* ---------- gallery ---------- */
    var slides = root.querySelectorAll('[data-bp-slide]');
    root.querySelectorAll('[data-bp-thumb]').forEach(function (th) {
      th.addEventListener('click', function () {
        var idx = th.getAttribute('data-bp-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-bp-slide') === idx); });
        root.querySelectorAll('[data-bp-thumb]').forEach(function (o) {
          o.setAttribute('aria-current', o === th ? 'true' : 'false');
        });
      });
    });

    /* ---------- sticky bar ---------- */
    if (el.sticky) {
      var anchor = root.querySelector('[data-bp-plans]');
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            el.sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }, { threshold: 0 }).observe(anchor);
      }
    }

    /* ---------- defaults: first available variant, Subscribe preselected ---------- */
    var first = null, i;
    for (i = 0; i < D.variants.length; i++) {
      if (D.variants[i].available) { first = D.variants[i]; break; }
    }
    if (!first) first = D.variants[0];
    state.variantId = first.id;

    var ps0 = first.plans || [];
    if (ps0.length) {
      state.mode = 'sub';
      state.weeks = ps0[0].weeks;
    } else {
      state.mode = 'one';
      state.weeks = null;
    }

    renderAll();
  }

  function boot() {
    document.querySelectorAll('[data-bpv2]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // A swap rewrote the URL, so Back must land on the right product.
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.bpv2) window.location.reload();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var n = e.target.querySelectorAll ? e.target.querySelectorAll('[data-bpv2]') : [];
    Array.prototype.forEach.call(n, init);
  });
})();
